import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import Footer from './Footer';

const MarketplacePage = () => {
  const features = [
    {
      icon: "🔧",
      title: "Trade Professionals",
      description: "Connect with licensed professionals across electrical, plumbing, HVAC, roofing, drywall, and more"
    },
    {
      icon: "👨‍💼",
      title: "Engineering Experts",
      description: "Licensed engineers specializing in structural, civil, mechanical, electrical, and software engineering"
    },
    {
      icon: "🏠",
      title: "Real Estate Services",
      description: "Professional real estate agents, property management, and home staging services"
    },
    {
      icon: "💼",
      title: "Job Bidding System",
      description: "Post jobs and get competitive bids from multiple qualified professionals in your area"
    }
  ];

  // Stats removed - platform is new and starting fresh

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-teal-900">
      {/* Navigation */}
      <nav className="bg-black/20 backdrop-blur-lg border-b border-white/10">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14 sm:h-16">
            <div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
              <Link 
                to="/"
                className="inline-flex items-center text-white hover:text-blue-300 transition-colors duration-200 mr-4"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Home
              </Link>
              <div className="text-xl sm:text-2xl md:text-3xl">🏪</div>
              <span className="text-sm sm:text-lg md:text-xl lg:text-2xl font-bold text-white truncate">
                D.C.T. Marketplace
              </span>
            </div>
            <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
              <Link to="/auth">
                <Button 
                  variant="outline" 
                  className="border-white/50 text-white bg-white/20 hover:bg-white/30 active:bg-white/40 text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2"
                  style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                    color: 'white'
                  }}
                >
                  Sign In
                </Button>
              </Link>
              <Link to="/auth">
                <Button 
                  className="bg-gradient-to-r from-blue-500 to-purple-600 text-white text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2"
                  style={{
                    background: 'linear-gradient(to right, #3b82f6, #8b5cf6)',
                    color: 'white'
                  }}
                >
                  Get Started
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-12 sm:py-20 md:py-32 px-3 sm:px-4">
        <div className="max-w-7xl mx-auto text-center">
          <div className="mb-6 sm:mb-8 animate-pulse">
            <Badge className="bg-gradient-to-r from-blue-500 to-purple-500 text-white text-sm sm:text-base md:text-lg px-4 sm:px-6 py-1 sm:py-2">
              🏗️ Complete Trade Solutions + Professional Engineering
            </Badge>
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-bold text-white mb-6 sm:mb-8 leading-tight">
            Your Complete
            <span className="block bg-gradient-to-r from-blue-400 via-purple-400 to-teal-400 bg-clip-text text-transparent">
              Professional Solution
            </span>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/80 mb-8 sm:mb-12 max-w-4xl mx-auto leading-relaxed px-2">
            Connect with certified professionals across all trades plus licensed engineers and interior designers. 
            From electrical and plumbing to software engineering and architectural design - everything you need in one platform.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-6 justify-center items-center mb-12 sm:mb-16 px-2">
            <Link to="/auth">
              <Button 
                size="lg" 
                className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-purple-600 text-white text-sm sm:text-lg md:text-xl px-6 sm:px-8 md:px-12 py-3 sm:py-4 md:py-6 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-2xl"
                style={{
                  background: 'linear-gradient(to right, #3b82f6, #8b5cf6)',
                  color: 'white'
                }}
              >
                Book Services
              </Button>
            </Link>
            <Link to="/subscription">
              <Button 
                size="lg" 
                className="w-full sm:w-auto bg-gradient-to-r from-green-500 to-emerald-600 text-white text-sm sm:text-lg md:text-xl px-6 sm:px-8 md:px-12 py-3 sm:py-4 md:py-6 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-2xl"
                style={{
                  background: 'linear-gradient(to right, #10b981, #059669)',
                  color: 'white'
                }}
              >
                Join as Provider
              </Button>
            </Link>
            <Link to="/auth">
              <Button 
                size="lg" 
                variant="outline" 
                className="w-full sm:w-auto border-2 border-white/50 text-white bg-white/20 text-sm sm:text-lg md:text-xl px-6 sm:px-8 md:px-12 py-3 sm:py-4 md:py-6 rounded-xl sm:rounded-2xl shadow-lg sm:shadow-2xl"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                  color: 'white'
                }}
              >
                Learn More
              </Button>
            </Link>
          </div>

          {/* Stats section removed - platform is new */}
        </div>
      </section>

      {/* Features Section */}
      <section className="py-32 px-4 bg-black/20 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              All Trades + Professional Engineering
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              From trades and construction to professional engineering and interior design services
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <Card 
                key={index} 
                className="bg-white/10 backdrop-blur-lg border-white/20 bg-white/10  transform  hover:rotate-1"
              >
                <CardContent className="p-8 text-center">
                  <div className="text-6xl mb-6 animate-bounce">{feature.icon}</div>
                  <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
                  <p className="text-white/70 text-lg leading-relaxed">{feature.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Trades Section */}
      <section className="py-32 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Professional Services Across All Trades & Engineering
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              Our certified professionals and engineers cover every aspect of construction, design, and technology solutions
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[
              { icon: "⚡", title: "Electrical", services: "Installation, Repair, Smart Systems" },
              { icon: "🔧", title: "Plumbing", services: "Pipes, Water Heaters, Emergency Repair" },
              { icon: "❄️", title: "HVAC", services: "Heating, Cooling, Duct Cleaning" },
              { icon: "🏠", title: "Roofing", services: "Installation, Repair, Gutters" },
              { icon: "🔨", title: "Carpentry", services: "Flooring, Tile Work, Custom Work" },
              { icon: "🎨", title: "Painting", services: "Interior, Exterior, Commercial" },
              { icon: "🌿", title: "Landscaping", services: "Design, Maintenance, Tree Service" },
              { icon: "🛠️", title: "Maintenance", services: "Emergency Services, Inspection" },
              { icon: "⚙️", title: "Mechanical Eng.", services: "System Design, Analysis, Consulting" },
              { icon: "🏗️", title: "Civil Eng.", services: "Infrastructure, Site Planning, Permits" },
              { icon: "🔩", title: "Structural Eng.", services: "Load Analysis, Building Design" },
              { icon: "💻", title: "Software Eng.", services: "Custom Development, System Design" },
              { icon: "🏡", title: "Interior Design", services: "Space Planning, Color, Furniture" },
              { icon: "📐", title: "Engineering", services: "Professional Consultation, Project Mgmt" },
              { icon: "🧱", title: "Drywall", services: "Installation, Repair, Texturing" },
              { icon: "🏘️", title: "Real Estate", services: "Sales, Property Management, Staging" }
            ].map((trade, index) => (
              <Card 
                key={index} 
                className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border-white/20"
              >
                <CardContent className="p-6 text-center">
                  <div className="text-4xl mb-4">{trade.icon}</div>
                  <h3 className="text-xl font-bold text-white mb-2">{trade.title}</h3>
                  <p className="text-white/60 text-sm">{trade.services}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-8">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-white/80 mb-12">
            Join thousands of satisfied customers who trust D.C. Technology Corp. for their home and business needs across all trades
          </p>
          <Link to="/auth">
            <Button 
              size="lg"
              className="bg-gradient-to-r from-teal-500 to-blue-500   text-white text-2xl px-16 py-8 rounded-2xl shadow-2xl transform  "
            >
              Join D.C. Technology Corp. Today
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MarketplacePage;